/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useTranslation } from "react-i18next";

interface FooterProps {
	totalVariance: number;
	unit: string;
	setShowModal: () => void;
}

const SReconcileMediaFooter: React.FC<FooterProps> = ({
	totalVariance,
	unit,
	setShowModal,
}) => {

	const { t } = useTranslation();
	return (
		<>
			{/* Footer Actions */}
			<footer className="fixed bottom-0 right-0 left-64 bg-white border-t border-gray-200 p-6 flex items-center justify-between z-40 shadow-[0_-10px_20px_-15px_rgba(0,0,0,0.1)]">
				<div className="flex gap-4">
					{/* <button className="px-8 py-3 bg-white border border-gray-200 text-slate-600 rounded-lg font-black text-[11px] uppercase tracking-widest hover:bg-gray-50 active:scale-95 transition-all">
						{ t('mediaReconcile.physicalReconciliation.saveAsDraft')}
					</button> */}
				</div>

				<div className="flex items-center gap-12">
					<div className="text-right">
						<p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1">
							{t("mediaReconcile.physicalReconciliation.totalReconciliationVariance")}
						</p>
						<p
							className={`text-xl font-black ${totalVariance < 0 ? "text-red-500" : "text-emerald-500"}`}
						>
							{totalVariance > 0 ? "+" : ""}
							{totalVariance.toLocaleString(undefined, {
								minimumFractionDigits: 2,
								maximumFractionDigits: 2,
							})}{" "}
							{unit}
						</p>
					</div>
					<button
						onClick={setShowModal}
						className="flex items-center gap-3 px-10 py-3 bg-[#FF7043] text-white rounded-lg font-black text-sm uppercase tracking-widest shadow-lg shadow-orange-500/30 hover:brightness-110 active:scale-95 transition-all border-none"
					>
						<span className="material-symbols-outlined text-lg">
							check_circle
						</span>
						{t("mediaReconcile.physicalReconciliation.postReconciliationAndAdjustmentStock")}
					</button>
				</div>
			</footer>
		</>
	);
};

export default SReconcileMediaFooter;
